/**
 * @generated SignedSource<<9bd04ba7bd85e42223b76d733db9a019>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueRealtimeUpdater_nativeIssueTable_groups$data = {
  readonly __id: string;
  readonly edges: ReadonlyArray<{
    readonly __typename: "JiraSpreadsheetGroupEdge";
  } | null | undefined> | null | undefined;
  readonly groupByField: string | null | undefined;
  readonly jql: string | null | undefined;
  readonly " $fragmentType": "issueRealtimeUpdater_nativeIssueTable_groups";
};
export type issueRealtimeUpdater_nativeIssueTable_groups$key = {
  readonly " $data"?: issueRealtimeUpdater_nativeIssueTable_groups$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueRealtimeUpdater_nativeIssueTable_groups">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "issueRealtimeUpdater_nativeIssueTable_groups",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "jql"
    },
    {
      "kind": "ScalarField",
      "name": "groupByField"
    },
    {
      "concreteType": "JiraSpreadsheetGroupEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        }
      ]
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraSpreadsheetGroupConnection"
};

(node as any).hash = "ca6d0461483850f259bdd43a5cf4138a";

export default node;
